
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { IndicatorsApiClient } from "../clients/IndicatorsApiClient";
import { IIndicatorStatusHistory } from "./models/IIndicatorStatusHistory";
import { IGetIndicatorStatusHistoryParameters } from "./models/IGetIndicatorStatusHistoryParameters";
import { IAverageIndicatorStatusHistory } from "./models/IAverageIndicatorStatusHistory";
import { IGetIndicatorStatusHistoryByDayParameters } from "./models/IGetIndicatorStatusHistoryByDayParameters";
import { IGetIndicatorStatusHistoryByPointsParameters } from "./models/IGetIndicatorStatusHistoryByPointsParameters";
import { INumericTimeSeriesPoints } from "./models/INumericTimeSeriesPoints";
import { IIndicatorEvent } from "./models/IIndicatorEvent";
import { IGetIndicatorEventsParameters } from "./models/IGetIndicatorEventsParameters";
import { IGetIndicatorsForComponentParameters } from "./models/IGetIndicatorsForComponentParameters";
import { IGetIndicatorsForComponentsParameters } from "./models/IGetIndicatorsForComponentsParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class IndicatorStatusHistoryService
{
	private readonly url: string;

	constructor(private readonly apiClient: IndicatorsApiClient)
    {
        this.url = "indicatorstatushistory";
    }

    async getIndicatorStatusHistory(parameters: IGetIndicatorStatusHistoryParameters): Promise<IIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IIndicatorStatusHistory[]>(`${this.url}/history`,{},JSON.stringify(parameters));
    }

    async getIndicatorStatusHistoryByDay(parameters: IGetIndicatorStatusHistoryByDayParameters): Promise<IAverageIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IAverageIndicatorStatusHistory[]>(`${this.url}/days`,{},JSON.stringify(parameters));
    }

    async getIndicatorStatusHistoryByPoints(parameters: IGetIndicatorStatusHistoryByPointsParameters): Promise<IAverageIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IAverageIndicatorStatusHistory[]>(`${this.url}/points`,{},JSON.stringify(parameters));
    }

    async getNumericTimeSeriesPoints(parameters: IGetIndicatorStatusHistoryByPointsParameters): Promise<INumericTimeSeriesPoints>
    {
        return await this.apiClient.post<INumericTimeSeriesPoints>(`${this.url}/timeseries`,{},JSON.stringify(parameters));
    }

    async getIndicatorEvents(parameters: IGetIndicatorEventsParameters): Promise<IIndicatorEvent[]>
    {
        return await this.apiClient.post<IIndicatorEvent[]>(`${this.url}/events`,{},JSON.stringify(parameters));
    }

    async getIndicatorsForComponent(parameters: IGetIndicatorsForComponentParameters): Promise<IIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IIndicatorStatusHistory[]>(`${this.url}/component`,{},JSON.stringify(parameters));
    }

    async getFailingIndicators(parameters: IGetIndicatorsForComponentParameters): Promise<IIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IIndicatorStatusHistory[]>(`${this.url}/failing`,{},JSON.stringify(parameters));
    }

    async getIndicatorsForComponents(parameters: IGetIndicatorsForComponentsParameters): Promise<IIndicatorStatusHistory[]>
    {
        return await this.apiClient.post<IIndicatorStatusHistory[]>(`${this.url}/components`,{},JSON.stringify(parameters));
    }

    async addInParallel(indicatorStatusHistories: IIndicatorStatusHistory[]): Promise<void>
    {
        this.apiClient.post(`${this.url}/add/parallel`,{},JSON.stringify(indicatorStatusHistories));
    }

    async getIndicatorStatusHistoryByDayRealtTime(componentId: number, indicatorId: number): Promise<IAverageIndicatorStatusHistory[]>
    {
        return await this.apiClient.get<IAverageIndicatorStatusHistory[]>(`${this.url}/today/${componentId}/${indicatorId}`);
    }
}
